<template>
  <div>
    <div class="home-search" :class="{ modified: modifyStyle }">
      <el-select
        class="my-el-select"
        v-model="value"
        placeholder="请选择"
        style="width: 110px; height: 40px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        class="my-input-home"
        v-model="crewValue"
        placeholder="请输入你想要搜索的职位"
      ></el-input>
      <el-button type="primary" class="my-button-home" @click="jobSearch"
        >搜索</el-button
      >
    </div>
    <p class="search-p" :class="{ 'search-white': modifyStyle }"></p>
    <div class="job-bottom">
      <div class="job-content">
        <div class="job-search">
          <div class="job-pro">排序方式:</div>
          <div
            :class="
              sortIndex == 0
                ? 'job-new'
                : sortIndex == 1
                ? 'job-old'
                : 'job-new'
            "
            @click="changeSort(0)"
          >
            默认
          </div>
          <div
            :class="
              sortIndex == 0
                ? 'job-old'
                : sortIndex == 1
                ? 'job-new'
                : 'job-old'
            "
            @click="changeSort(1)"
          >
            最新
          </div>
        </div>
        <div class="jobs-list" v-for="(item, index) in trainList" :key="index">
          <div class="jobs-title">
            <div class="jobs-font">{{ item.trainTitle }}</div>
            <div class="trains-prize">{{ item.trainPrice }}元</div>
            <!-- <div class="jobs-last">
              <div class="jobs-plan">
                剩<span
                  :style="{ color: item.planNum <= 5 ? '#ef5151' : '#2aba48' }"
                  >{{ item.planNum }}</span
                >个名额
              </div>
              <div class="jobs-pub">{{ item.publishTime }}开课</div>
            </div> -->
          </div>
          <div class="jobs-minu">
            <div class="fuli-list">
              <div>热门培训</div>
              <div>名额有限</div>
            </div>
            <div class="jobs-time">
              <span style="margin-right: 10px">{{ item.companyName }}</span>
              <span class="jobs-pub">{{ item.reportTime }}开课</span>
            </div>
          </div>
          <div class="jobs-fuli">
            <div class="jobs-last">
              <div class="jobs-plan">
                剩<span
                  :style="{ color: item.planNum <= 5 ? '#ef5151' : '#2aba48' }"
                  >{{ item.planNum }}</span
                >个名额
              </div>
            </div>
            <div class="chaka-bottom" @click="gotoTrain(item)">查看培训</div>
          </div>
        </div>
        <div class="no-data text-center" v-if="trainList.length == 0">
          <img src="@/assets/nodata.png" alt="" />
        </div>
        <div class="page-aiton" v-if="total > 0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="job-right">
        <div class="more-title">
          <div class="more-line"></div>
          <div class="more-font">职位推荐</div>
        </div>
        <div
          class="more-job"
          v-for="(item, index) in jobList"
          :key="index"
          @click="gotoJob(item)"
        >
          <div class="job-title">
            <div class="job-name">{{ item.positionName }}</div>
            <div class="job-sal" v-if="!item.mianyi">
              {{ item.salaryBegin }}-{{ item.salaryEnd }}万元
            </div>
            <div class="job-sal" v-if="item.mianyi">
              {{ item.mianyi }}
            </div>
          </div>
          <div class="job-des">
            <span>{{ item.shipTypeName }}</span>
            <span>{{ item.recuritShipTon }}吨</span>
            <span
              >{{ item.workingYearBegin }}-{{
                item.workingYearEnd
              }}年航海经验</span
            >
            <span
              >{{ item.locationProvinceName }}-{{ item.locationPortName }}</span
            >
          </div>
          <div class="job-tags">
            <p v-if="item.welfareTag.length == 0"></p>
            <div v-for="val in item.welfareTag" :key="val">{{ val }}</div>
          </div>
          <!-- <div class="job-divd"></div> -->
          <div class="job-user">
            <div>{{ item.companyName }}</div>
            <div>{{ item.refreshTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryJobsList, selectAlITrainplanNotePublishList } from "@/apis/index";
import { apiUrl } from "@/config";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      test: "",
      crewValue: "",
      options: [
        {
          value: "1",
          label: "船员招聘",
        },
        {
          value: "2",
          label: "船员培训",
        },
      ],
      value: "2",
      sortIndex: "0",
      jobList: [],
      total: 0,
      searchParams: {
        pageSize: 3,
        pageNo: 1,
        timeSortType: 0,
      },
      trainList: [],
      scrollTop: 0,
      modifyStyle: false,
    };
  },
  mounted() {
    if (this.$route.params.positionOrCompany == "all") {
      this.searchParams.positionOrCompany = "";
    } else {
      this.searchParams.positionOrCompany =
        this.$route.params.positionOrCompany;
    }
    window.addEventListener("scroll", this.handleScroll);
    this.queryJobs();
    this.selectAlITrainplanNotePublish();
    // console.log(this.$route.params.positionOrCompany);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {},
  methods: {
    //滑动更改样式
    handleScroll() {
      this.scrollTop = window.scrollY || document.documentElement.scrollTop;
      // console.log(this.scrollTop);
      if (this.scrollTop >= 300) {
        this.modifyStyle = true;
      } else {
        this.modifyStyle = false;
      }
    },
    // 搜索框
    jobSearch() {
      if (this.value == 1) {
        if (this.crewValue != "") {
          this.$router.push({
            name: "jobDetail",
            params: { positionOrCompany: this.crewValue },
          });
        } else {
          this.$router.push({
            name: "jobDetail",
            params: { positionOrCompany: "all" },
          });
        }
      } else if (this.value == 2) {
        this.searchParams.trainTitle = this.crewValue;
        this.selectAlITrainplanNotePublish();
      }
    },
    //最新默认
    changeSort(type) {
      this.sortIndex = type;
      this.searchParams.timeSortType = type;
      this.selectAlITrainplanNotePublish();
    },
    handleSizeChange(size) {
      this.searchParams.pageSize = size;
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.selectAlITrainplanNotePublish();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNo = val;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 调用后台接口或重新获取数据
      // this.selectRecordList();
      this.selectAlITrainplanNotePublish();
    },
    //职位
    async queryJobs() {
      const res = await queryJobsList(this.searchParams);
      // console.log(res);
      const list = res.data.resultList;
      if (list && list.length) {
        list.forEach((item) => {
          item.welfareTag = JSON.parse(item.welfareTag);
          if (item.welfareTag.length > 3) {
            item.welfareTag = item.welfareTag.slice(0, 3);
          }

          item.refreshTime = item.refreshTime.split(" ")[0];
          item.salaryBegin = (item.salaryBegin / 10000).toFixed(2);
          item.salaryEnd = (item.salaryEnd / 10000).toFixed(2);
          if (item.salaryBegin == 0 && item.salaryEnd == 0) {
            item.mianyi = "面议";
          }
        });
        this.jobList = list;
        this.total = res.data.rowCount;
      } else {
        this.jobList = [];
        this.total = 0;
      }
    },
    //培训
    async selectAlITrainplanNotePublish() {
      const res = await selectAlITrainplanNotePublishList(this.searchParams);
      res.data.resultList.forEach((item) => {
        // item.welfareTag = JSON.parse(item.welfareTag);
        item.reportTime = item.reportTime.split(" ")[0];
      });
      this.trainList = res.data.resultList;
      this.total = res.data.rowCount;
    },
    navigateTo(url) {
      // 创建 XMLHttpRequest 对象
      var xhr = new XMLHttpRequest();

      // 监听请求状态变化
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          if (xhr.status === 200) {
            // 请求成功，执行页面跳转
            window.location.href = url;
          } else {
            // 请求失败，执行错误处理逻辑
            console.error("请求失败");
          }
        }
      };

      // 发送 GET 请求
      xhr.open("GET", url, true);
      xhr.send();
    },
    //招聘
    gotoJob(item) {
      if (
        sessionStorage.getItem("tolog") &&
        (sessionStorage.getItem("userType") == 0 ||
          sessionStorage.getItem("userType") == 5 ||
          sessionStorage.getItem("userType") == 4)
      ) {
        // console.log("1");
        // window.open(
        //   `${apiUrl}/crew_recruit_lsm/index.html#/login?tolog=${sessionStorage.getItem(
        //     "tolog"
        //   )}&idList=${item.jobId}`
        // );
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${
          item.jobId
        }/?tolog=${sessionStorage.getItem("tolog")}`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_recruit_lsm/index.html#/frame/postDetail/${item.jobId}/?homeTitle=true`;
      }
    },
    //培训
    gotoTrain(item) {
      if (
        (sessionStorage.getItem("tolog") &&
          sessionStorage.getItem("userType") == 0) ||
        sessionStorage.getItem("userType") == 4 ||
        (sessionStorage.getItem("userType") == 1 &&
          sessionStorage.getItem("isLand") == 0)
      ) {
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${
          item.id
        }/0?tolog=${sessionStorage.getItem("tolog")}`;
        // window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      } else {
        sessionStorage.clear();
        window.location.href = `${apiUrl}/crew_train_lsm/index.html#/frame/courseDetail/${item.id}/0?homeTitle=true`;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
